module.exports = __webpack_public_path__ + "static/media/4.971eb440.jpeg";